import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useRef, useState } from "react";
import { Fetch } from "../../../shared/Fetch";
import { IEscalations, IModel } from "./EscalationMaster";
import { safeFormatDate } from "../../../models/DateFormatMapper";
import { ILogin } from "../../../models/Login";
import { Toolbar } from "primereact/toolbar";
import { Dialog } from "primereact/dialog";
import { Card } from "primereact/card";

interface Iprops {
    setModal: (modal: IModel) => void,
    toast: any,
    reLoad: boolean,
    poID?: number | null,
}

interface IConsultants {
    consultant_ID?: number,
    consultant_Name?: string,
}

export const Table = (props: Iprops) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IEscalations>, loading: boolean });
    const [historyTableData, setHistoryTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IEscalations>, loading: boolean });
    const [openComment, setOpenComment] = useState({ open: false, singleData: {} } as { open: boolean, singleData: IEscalations });
    const [openCons, setOpenCons] = useState({ open: false, singleData: {} } as { open: boolean, singleData: IEscalations });
    const [openHistory, setOpenHistory] = useState({ open: false, singleData: {} } as { open: boolean, singleData: IEscalations });
    const [cons, setCons] = useState<Array<IConsultants>>([]);
    const dt = useRef<any>(null);

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");
    const DateFormat = loginObj?.date_Format;

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("POEscalation/getEscalations", "GET", null, ((props.poID !== undefined && props.poID !== null) ? `poID=${props.poID}` : null), props.toast);
        if (response) {
            const data: IEscalations[] = await response.json();
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    }

    const loadTableDataHistory = async (id: number) => {
        setHistoryTableData({ tableData: historyTableData.tableData, loading: true });
        const response = await Fetch("POEscalation/getEscalationHisotry", "GET", null, `escalationID=${id}`, props.toast);
        if (response) {
            const data: IEscalations[] = await response.json();
            setHistoryTableData({ tableData: data, loading: false });
        } else setHistoryTableData({ tableData: historyTableData.tableData, loading: false });
    }

    const loadTableDataConsultants = async (id: number) => {
        const response = await Fetch("POEscalation/getEscalationConsultants", "GET", null, `escalationID=${id}`, props.toast);
        if (response) {
            const data: any[] = await response.json();
            setCons(data);
        }
    }

    const openEdit = (rowData: any) => {
        props.setModal({
            open: true, singleData: {
                id: rowData.id,
                consultant_ID: rowData.consultant_ID.split(",").map((el: string) => Number(el.trim() || "0")),
                type_ID: rowData.type_ID,
                status_ID: rowData.status_ID,
                comment: rowData.comment,
                // vendor_Company_ID: rowData.vendor_Company_ID
            }
        });
    };

    const actionBodyTemplate = (rowData: any) => {
        return (
            <div className="actions">
                {(rowData.canEdit === true) && <Button icon="pi pi-pencil" className="p-button-rounded p-button-success p-button-text mr-1" onClick={() => openEdit(rowData)} />}
            </div>
        );
    };

    const openNew = () => {
        props.setModal({
            open: true, singleData: {
                isDC: true,
                consultant_ID: "",
                type_ID: 0,
                status_ID: 1,
                comment: "",
            }
        });
    };

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="my-2">
                    <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                </div>
            </React.Fragment>
        );
    };

    const history = (rowData: any) => {
        return (
            <Button onClick={() => {
                loadTableDataHistory(rowData.id);
                setOpenHistory({ open: true, singleData: rowData });
            }} icon="pi pi-history" className="p-button-rounded p-button-secondary p-button-text" aria-label="History" />
        );
    };

    useEffect(() => {
        loadTableData();
    }, [props.reLoad]);

    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate}></Toolbar>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" stripedRows showGridlines responsiveLayout="scroll" scrollHeight="65vh"
                value={tableData.tableData}
                header={<p>Escalation Status</p>}
                loading={tableData.loading}
            >
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                <Column field="consultant_ID" header="#Consultants" body={(rowData: any) => <p className="cursor-pointer text-cyan-700 underline" onClick={() => {
                    loadTableDataConsultants(rowData.id);
                    setOpenCons({ open: true, singleData: rowData });
                }}>{rowData.consultant_ID.split(",").map((el: string) => Number(el.trim() || "0")).length}</p>} />
                <Column field="type_Name" header="Type" />
                <Column field="status" header="Status" />
                <Column field="comment" header="Comment" body={(rowData: IEscalations) => <p className="cursor-pointer text-cyan-700 underline flex" onClick={() => setOpenComment({ open: true, singleData: rowData })}><p style={{ overflow: "hidden", width: "4rem", height: "2rem" }}>{rowData.comment}</p>...</p>} />
                <Column field="" header="History" body={history} />
                <Column field="created_By" header="Created By" />
                <Column field="created_At" header="Created At" body={(rowData: any) => safeFormatDate(rowData.created_At, "dd/MM/yyyy", DateFormat)} />
                <Column field="updated_By" header="Updated By" />
                <Column field="updated_At" header="Updated At" body={(rowData: any) => safeFormatDate(rowData.updated_At, "dd/MM/yyyy", DateFormat)} />
                <Column body={actionBodyTemplate} />
            </DataTable>
            <Dialog visible={openComment.open} style={{ width: '80vw' }} header="Comment" modal className="p-fluid" onHide={() => setOpenComment({ open: false, singleData: {} })}>
                <Card>
                    <p>{openComment.singleData.comment}</p>
                </Card>
            </Dialog>
            <Dialog visible={openCons.open} style={{ width: '80vw' }} header="Consultants" modal className="p-fluid" onHide={() => setOpenCons({ open: false, singleData: {} })}>
                <Card>
                    <div className="flex gap-1">
                        {cons.map((el: IConsultants) => <div style={{ border: "1px solid grey", padding: "3px", borderRadius: "5px" }}>{el.consultant_Name}</div>)}
                    </div>
                </Card>
            </Dialog>
            <Dialog visible={openHistory.open} style={{ width: '80vw' }} header="Comment" modal className="p-fluid" onHide={() => setOpenHistory({ open: false, singleData: {} })}>
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                    size="small" stripedRows showGridlines responsiveLayout="scroll" scrollHeight="65vh"
                    value={historyTableData.tableData}
                    header={<p>Escalation History</p>}
                    loading={historyTableData.loading}
                >
                    <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                    <Column field="type_Name" header="Type" />
                    <Column field="status" header="status" />
                    <Column field="comment" header="Comment" body={(rowData: any) => <p className="cursor-pointer text-cyan-700 underline flex" onClick={() => setOpenComment({ open: true, singleData: rowData })}><p style={{ overflow: "hidden", width: "4rem", height: "2rem" }}>{rowData.comment}</p>...</p>} />
                    <Column field="updated_By" header="Updated By" />
                    <Column field="updated_At" header="Updated At" body={(rowData: any) => safeFormatDate(rowData.updated_At, "dd/MM/yyyy", DateFormat)} />
                </DataTable>
            </Dialog>
        </>
    );
}